module.exports = __webpack_public_path__ + "img/s1bg.811c63e6.png";